module.exports = __webpack_public_path__ + "static/media/Barges.f591ee15.svg";